import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBBtn } from "mdbreact";
import { Beat } from "../../../../redux/reducers/spinner";
import { cleanInput } from "../../../../redux/helpers";
import { adminActions } from "../../../../redux/actions";
import PrimaryLoader from "../../../includes/Loaders/PrimaryLoader";

export default function EnhancedApplicationSettings() {
  const dispatch = useDispatch();
  const {
    settings,
    updatingSettings,
    loadingSettings,
    allCurrencies,
    loadingCurrency,
  } = useSelector((state) => state.admin);

  const [data, setData] = useState({
    push_notification_provider: settings?.push_notification_provider,
    sms_notification_provider: settings?.sms_notification_provider,
    mail_notification_provider: settings?.mail_notification_provider,
    order_report_mail_status: settings?.order_report_mail_status,
    google_places_status: settings?.google_places_status,
    platform_currency: { id: settings?.platform_currency?.id },
  });

  useEffect(() => {
    dispatch(adminActions.getApplicationSettings());
    dispatch(adminActions.getAllCurrencies());
  }, [dispatch]);

  useEffect(() => {
    if (!settings) return;
    setData(() => ({
      push_notification_provider: settings?.push_notification_provider,
      sms_notification_provider: settings?.sms_notification_provider,
      mail_notification_provider: settings?.mail_notification_provider,
      order_report_mail_status: settings?.order_report_mail_status,
      google_places_status: settings?.google_places_status,
      platform_currency: { id: settings?.platform_currency?.id || "" },
    }));
  }, [settings]);

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    if (name === "platform_currency") {
      setData((prev) => ({
        ...prev,
        [name]: { ...prev[name], id: value },
      }));
    } else {
      setData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleUpdate = async () => {
    cleanInput(data);
    const response = dispatch(
      adminActions.enhanceApplicationSettings({ ...data })
    );
    if (response.status === "success") {
      dispatch(adminActions.getApplicationSettings());
    }
  };

  return (
    <>
      {loadingSettings ? (
        <PrimaryLoader />
      ) : (
        <>
          <div className="w-100 mx-auto">
            <div className="mx-auto bg-white dark:bg-[#121212] sm:w-[630px] w-full mt-10 sm:mt-0 sm:border p-6 sm:border-gray-200 dark:border-none">
              <div className="border-b-2 dark:border-[#505050] py-4 mb-6">
                <p className=" text-base font-medium text-gray-800 dark:text-white flex justify-center ">
                  Update Enhanced Application Settings
                </p>
              </div>

              <form>
                <div className=" sm:px-10 mb-10">
                  <div className={"form-group col-md-12 mb-4"}>
                    <label htmlFor="push_notification_provider">
                      Push Notification Provider
                    </label>
                    <select
                      className="form-control"
                      name="push_notification_provider"
                      value={data?.push_notification_provider}
                      onChange={handleChange}
                    >
                      <option>Select Provider</option>
                      <option value={"default"}>Default</option>
                      <option value={"expo"}>Expo</option>
                      <option value={"firebase"}>Firebase</option>
                    </select>
                  </div>
                  <div className={"form-group col-md-12 mb-4"}>
                    <label htmlFor="sms_notification_provider">
                      Sms Notification Provider
                    </label>
                    <select
                      className="form-control"
                      name="sms_notification_provider"
                      value={data?.sms_notification_provider}
                      onChange={handleChange}
                    >
                      <option>Select Provider</option>
                      <option value={"termii"}>Termii</option>
                      <option value={"twilio"}>Twilio</option>
                    </select>
                  </div>
                  <div className={"form-group col-md-12 mb-4"}>
                    <label htmlFor="mail_notification_provider">
                      Mail Notification Provider
                    </label>
                    <select
                      className="form-control"
                      name="mail_notification_provider"
                      value={data?.mail_notification_provider}
                      onChange={handleChange}
                    >
                      <option>Select Provider</option>
                      <option value={"default"}>Default</option>
                      <option value={"xend"}>Xend</option>
                    </select>
                  </div>
                  <div className={"form-group col-md-12 mb-4"}>
                    <label htmlFor="order_report_mail_status">
                      Order Report Mail Status
                    </label>
                    <select
                      className="form-control"
                      name="order_report_mail_status"
                      value={data?.order_report_mail_status}
                      onChange={handleChange}
                    >
                      <option>Select Status</option>
                      <option value={"available"}>Available</option>
                      <option value={"unavailable"}>Unavailable</option>
                    </select>
                  </div>
                  <div className={"form-group col-md-12 mb-4"}>
                    <label htmlFor="google_places_status">
                      Google Places Status
                    </label>
                    <select
                      className="form-control"
                      name="google_places_status"
                      value={data?.google_places_status}
                      onChange={handleChange}
                    >
                      <option>Select Status</option>
                      <option value={"available"}>Available</option>
                      <option value={"unavailable"}>Unavailable</option>
                    </select>
                  </div>
                  <div className={"form-group col-md-12 mb-4"}>
                    <label htmlFor="platform_currency">Platform Currency</label>
                    <select
                      className="form-control"
                      name="platform_currency"
                      value={data?.platform_currency?.id}
                      onChange={handleChange}
                    >
                      <option>Select Currency</option>
                      {loadingCurrency ? (
                        <option>Loading...</option>
                      ) : (
                        Object.keys(allCurrencies).map((key) => (
                          <option
                            key={allCurrencies[key]?.id}
                            value={allCurrencies[key]?.id}
                          >
                            {allCurrencies[key]?.alphabetic_code}
                          </option>
                        ))
                      )}
                    </select>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="flex justify-center mx-auto">
            <MDBBtn color="primary" type="button" onClick={handleUpdate}>
              {updatingSettings ? (
                <Beat loading={updatingSettings} />
              ) : (
                "Update Settings"
              )}
            </MDBBtn>
          </div>
        </>
      )}
    </>
  );
}
